import React, {useEffect, useRef, useState} from 'react';
import { Route, Switch } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import {Query, useMutation, useSubscription} from 'react-apollo';
import {LISTEN_ROOM_MESSAGES} from 'graphql/chat';
import Spin from 'components/common/Spin';
import {useSelector} from "react-redux";
import Message from "../../student/chat/components/Message";
import CardContent from "@material-ui/core/CardContent";


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 170px)',
    overflow: 'scroll',
  },
}));

const Room = ({ room }) => {
  const classes = useStyles();
  const listRef = useRef();
  const user = useSelector((s) => s.user.user);
  const { data, loading } = useSubscription(LISTEN_ROOM_MESSAGES, {
    variables: { id: room.room_id },
  });

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [data]);

  return (
    <CardContent component={Paper} className={classes.root} ref={listRef}>
      {data?.messages.map((m) => (
        <Message
          user={user}
          message={m}
          userId={user.id}
          key={m.id}
        />
      ))}
      <Spin spinning={loading} linear />
    </CardContent>
  )
};

export default Room;
